import type { UiStrings } from '../types'

const es: UiStrings = {
  brand: 'Holecard EX',
  docTitleSuffix: 'Registro de proceso',
  tagline: 'Registra asiento · holes · board · línea — carta de proceso para compartir',
  metaDescription:
    'Holecard EX — registro de proceso de póker móvil. Registra asiento, hole cards, board y acciones por calle en una carta compartible.',
  stepsAria: 'Pasos',
  prev: 'Atrás',
  undo: 'Deshacer',
  next: 'Siguiente',
  nextSummary: 'Ver resumen',
  privacyLink: 'Privacidad y anuncios',
  privacyTitle: 'Privacidad y anuncios',
  privacyHint: 'Borrador para revisión de AdSense. Revíselo y actualícelo antes de producción.',
  privacyBack: 'Volver a la app',
  privacyCollectTitle: '1. Información que recopilamos',
  privacyCollectBody:
    'Holecard EX actualmente arma borradores de revisión solo en el navegador. No requiere cuenta y los datos de la mano no se envían a un servidor. Los borradores pueden guardarse temporalmente en sessionStorage de esta pestaña (esta política se actualizará si cambia).',
  privacyAdsTitle: '2. Cookies y anuncios',
  privacyAdsBody:
    'Pueden usarse redes publicitarias de terceros como Google AdSense. Los anunciantes pueden usar cookies o identificadores de dispositivo para anuncios basados en intereses. Puede controlar los anuncios personalizados en el navegador o en la configuración de anuncios de Google.',
  privacyContactTitle: '3. Contacto',
  privacyContactBody: 'Para preguntas de política, abra un issue de GitHub de holdcard-ex.com. Email del operador: TODO_OPERATOR_EMAIL en la config del proyecto.',
  langAria: 'Idioma',
  langCompactAria: 'Idioma (compacto)',
  koPathLink: '한국어',
  koPathLinkAria: 'Versión en coreano (/ko)',
  enPathLink: 'English',
  enPathLinkAria: 'Versión en inglés (/)',
  setupTitle: 'Mesa',
  setupHint: 'Jugadores · stack · ciegas — luego Asiento → Mano → Línea',
  players: 'Jugadores',
  playersUnit: (n) => `${n}-max`,
  sb: 'SB',
  bb: 'BB',
  ante: 'Ante (opcional)',
  anteHint: 'Misma unidad que las ciegas',
  effectiveStack: 'Stack efectivo (BB, opcional)',
  potBb: 'Bote (BB, opcional)',
  metaOptionalHint: 'Deje ante / stack eff / bote vacíos para ocultarlos en resúmenes',
  setupDetailsToggle: 'Jugadores · ante · eff · bote · fichas',
  setupBasicsHint: 'Por defecto (6-max · 100bb) ok — Siguiente o saltar',
  setupMetaSetChip: 'Ante · eff · bote definidos',
  stackUnit: 'Unidad del stack',
  stackUnitBb: 'BB',
  stackUnitChips: 'Fichas',
  stackChips: 'Stack (fichas)',
  stackBb: 'Stack (BB)',
  stackChipsUnit: 'fichas',
  positionTitle: 'Asiento',
  seatQuestion: '¿Dónde te sentaste?',
  settingsBack: 'Volver',
  settingsSegAria: 'Ajustes de mesa (jugadores · ciegas · stack)',
  lineSeatEditAria: 'Editar asiento',
  lineHoleEditAria: 'Editar cartas',
  positionHint: (count, hint) => `${count}-max asientos${hint ? ` · ${hint}` : ''}`,
  tableVizAria: (n) => `Asientos mesa ${n}-max`,
  tableVizHeroBadge: 'tú',
  tableVizHeroSeatAria: (seat) => `${seat} (tú)`,
  tableVizDealer: 'D',
  tableVizDealerTitle: 'Botón del crupier',
  tableVizTapHint: 'Toca tu asiento en la mesa',
  tableVizListFallback: 'Listar asientos · códigos',
  tableVizBlindsAria: (v) => `Ciegas ${v}`,
  tableVizPotPlaceholder: 'Bote',
  tableVizPotValue: (v) => `Bote ${v}`,
  tableVizPotAria: (v) => `Bote ${v}`,
  tableVizStackAria: (v) => `Stack ${v}`,
  tableVizEmptyMark: '—',
  tableVizEffHint: (v) => `Eff ${v}bb`,
  tableVizEffTitle: 'Stack efectivo (de la mesa, no por asiento)',
  tableVizStepDown: 'Bajar',
  tableVizStepUp: 'Subir',
  tableVizEditDone: 'Listo',
  tableVizInfoHint: 'Toca ciegas, bote o stack en la mesa para editar',
  seatAbbrevHint: 'Abreviaturas de asiento. Toca para el nombre completo.',

  cardsTitle: 'Mano',
  cardsHint: 'Empiece con sus cartas · rivales vía «Añadir rivales» · slot · palo y valor · sin duplicados',
  heroHolesGuide: (seat) => `Elige las 2 hole cards de ${seat}.`,
  cardSlot1: 'Carta 1',
  cardSlot2: 'Carta 2',
  cardSlotSelect: 'Elegir',
  seatsLabel: 'Asientos',
  knownHolesOptional: 'Las hole cards rivales son opcionales (showdown / revisión — vacío OK)',
  holesBySeat: 'Hole cards · elija asiento',
  seatVillain: (pos) => `Villano ${pos}`,
  seatFilled: 'Listo',
  holesModeHeroOnly: 'Solo mis cartas',
  holesModeWithVillains: 'Añadir rivales',
  holesModeAria: 'Modo de entrada de hole cards',
  villainNudgeToast: '¿Conoce una mano rival? Toque BB / CO etc.',
  heroCardsDoneCta: 'Ir a la línea',
  heroCardsAddVillainsCta: 'Añadir rivales',
  suitPickerLabel: 'Palo',
  rankPickerLabel: 'Valor',
  boardTitle: 'Board',
  boardHint: 'Cuando llegues — saltar si solo preflop',
  flop: 'Flop',
  turn: 'Turn',
  river: 'River',
  flopSlot: (i) => `F${i}`,
  actionsTitle: 'Línea',
  actionsHint: 'Línea de acciones por calle — fold / check / call / bet / raise / all-in',
  actorQuick: 'Actor rápido',
  actor: 'Actor',
  actorPlaceholder: 'Introducir nombre',
  actorCustomToggle: 'Nombre personalizado',
  actorRequired: 'Introduzca o seleccione un actor',
  action: 'Acción',
  sizeLabel: 'Tamaño',
  sizePlaceholder: 'p. ej. 2.5bb',
  sizeRequired: 'Introduzca tamaño para bet/raise',
  sizeCustomToggle: 'Personalizado',
  sizeOpenApprox: 'Open',
  sizePotApprox: 'Tamaño del bote',
  sizeOverbetApprox: 'Overbet',
  sizeJamApprox: 'Short / jam',
  sizeUnitBb: 'bb',
  sizeUnitPct: 'pot',
  snapHint: 'Encaja en stops · ± un paso',
  favoritesLabel: 'Favoritos',
  morePresets: 'Más presets',
  presetsSizeLabel: 'Presets · tamaño',
  potSizeHintUnset: 'Defina el bote (BB) en setup para ver el tamaño como bb',
  clearOptional: 'Borrar',
  betRaiseHint: 'Bet: sin agresión previa · Raise: frente a bet/raise',
  allinSizeHint: 'Tamaño all-in opcional',
  sizeActionHint: (potBit) => potBit ? `Bet=primero · Raise=vs bet · ${potBit}` : 'Bet=primero · Raise=vs bet',
  addAction: (street) => `Añadir acción de ${street}`,
  updateAction: 'Actualizar',
  editAction: 'Editar',
  cancelEdit: 'Cancelar edición',
  noStreetActions: (street) => `Aún no hay acciones de ${street}.`,
  delete: 'Eliminar',
  moveUp: 'Subir',
  moveDown: 'Bajar',
  allActionsHint: (n) => `${n} acciones en total · revise otras pestañas`,
  heroChip: (pos) => pos,
  seatOrderHu: 'HU: BTN actúa como SB · orden BTN/SB → BB',
  seatOrder: (order) => `Orden de asientos: ${order}`,
  positionHintHuBtn: 'Botón HU (SB)',
  keepActorHint: 'Las pestañas de calle conservan el actor (solo se reinician tipo/tamaño)',
  potQuickPrompt: 'Bote rápido (BB) — toque para definir y actualizar la pista',
  potQuickClear: 'Borrar bote',
  quickLinesLabel: 'Líneas rápidas',
  quickLinesHint: 'Plantillas comunes — toque para añadir',
  macroOpenThenCall: 'Open luego call',
  macroFoldToHero: (seat) => `Folds hasta ${seat}`,
  macroCbet33: 'C-bet ⅓ pot',
  quickLinesSwitchStreet: 'Cambie de calle para macros',
  macroOpenExists: 'Ya hay un open (raise) registrado',
  macroAlreadyLogged: 'Open y call ya están registrados',
  macroFoldToHeroNone: (seat) => `No quedan folds tempranos (o ${seat} actúa primero)`,
  macroFoldToHeroBlocked: 'Ya hay acción temprana — añade folds a mano',
  boardCtaFlop: 'Añadir flop',
  boardCtaTurn: 'Añadir turn',
  boardCtaRiver: 'Añadir river',
  quickHand: 'Mano rápida',
  skipToCards: 'Ir a cartas',
  jumpToActions: 'Ir a la línea',
  skipBoardPreflop: 'Saltar board — solo preflop',
  boardSlotsToggle: 'Añadir cartas del board',
  softStackAria: 'Mano hasta ahora',
  softStackLine: 'Línea',
  softStackHoles: 'Holes',
  softStackBoard: 'Board',
  streetTabWithCount: (street, n) => `${street} · ${n}`,
  actionIndexLabel: (n, street) => `Acción ${n} · ${street}`,
  copyLinkTitle: 'Vuelve a abrir esta mano en la app',
  suitStickyHint: 'Palo fijado · toque un palo para cambiar',
  suitStickyChip: (s) => `Palo actual ${s}`,
  suitMruLabel: 'Recientes',
  summaryHint: 'Capture la carta de proceso de abajo o copie/comparta el texto',
  summaryHole: 'Hole cards',
  summaryBoard: 'Board',
  summaryActions: 'Acciones',
  timelineProcess: 'Proceso',
  timelineBoard: (cards) => `Board ${cards}`,
  processMoreSummary: 'Más proceso',
  linePeekSummary: 'Línea hasta ahora',
  takeawayLabel: 'Conclusión',
  takeawayPlaceholder: 'Solo asiento + línea — ej. BTN raise, BB call, flop check',
  takeawayHint: 'Una línea de proceso — solo asiento + línea',
  takeawayNudge: 'Nota del proceso (opcional)\u00a0· asiento\u00a0· línea',
  takeawayInLinkFact: 'La nota de proceso está en el enlace',
  shareSecondarySummary: 'Nota · rivales (opcional)',
  shareSecondaryInvite: 'Deja una línea de proceso (opcional)',
  shareMoreSummary: 'Otras formas de compartir',
  lineDraftSummary: 'Actor · tamaño',
  explainModeLabel: 'Explicar',
  explainModeAria: 'Modo explicación — mostrar pistas',
  reviewScopeLabel: 'Revisar hasta',
  reviewScopePreflop: 'Preflop',
  reviewScopeFlop: 'Flop',
  reviewScopeRiver: 'River',
  reviewScopeAria: 'Alcance de revisión — pliega calles posteriores (no borra)',
  shareProcessHu: 'Heads-up',
  shareProcessMultiway: 'Multiway',
  shareReviewedLabel: 'Revisado',
  summaryCopyLabel: 'Pegar en el chat — legible + Pro',
  summaryProLabel: 'Notación Pro',
  emptyDash: '—',
  copyBoth: 'Compartir al chat',
  copyHuman: 'Legible',
  copyPro: 'Notación Pro',
  copied: 'Copiado ✓',
  copiedToast: 'Resumen copiado',
  screenshotHint: 'Captura = foto limpia · Enlace = reabrir la mano',
  captureMode: 'Captura',
  captureExit: 'Salir de captura',
  saveShareImage: 'Guardar imagen',
  shareImage: 'Compartir imagen',
  imageSaved: 'Guardado ✓',
  imageShared: 'Compartido ✓',
  imageSavedToast: 'Imagen guardada',
  imageSharedToast: 'Imagen compartida',
  imageFailedToast: 'No se pudo crear la imagen',
  shareText: 'Compartir texto',
  shared: 'Compartido ✓',
  copyLink: 'Copiar enlace',
  linkCopiedToast: 'Enlace de mano copiado',
  linkWithoutKnownHolesToast: 'Enlace copiado sin hole cards rivales (demasiado largo)',
  linkTooLongToast: 'Mano demasiado grande para un enlace',
  sharedToast: 'Compartido',
  shareFailedToast: 'Error al compartir',
  newHand: 'Nueva mano',
  receivedQuietRerecordCta: 'Registrar mi propio proceso',
  draftRestoredHint: 'Borrador restaurado — ¿continuar o empezar de nuevo?',
  draftContinue: 'Continuar',
  actorFoldedHint: 'Ya fold',
  summaryHeading: '[Resumen Holecard EX]',
  summaryPlayers: (n) => `Jugadores: ${n}-max`,
  summaryBlinds: (b) => `Ciegas: ${b}`,
  summaryHero: (p) => `Asiento: ${p}`,
  summaryStack: (s) => `Stack: ${s}`,
  summaryEff: (e) => `Stack eff: ${e} BB`,
  summaryPot: (p) => `Bote: ${p} BB`,
  summaryHoleLine: (h) => `Hole: ${h}`,
  summaryHolesHeader: 'Holes:',
  summaryKnownHoleLine: (label, cards) => `· ${label}: ${cards}`,
  summaryBoardLine: (b) => `Board: ${b}`,
  summaryActionsHeader: '── Acciones ──',
  summaryFooter: '— Hecho con Holecard EX',
  summaryProHeader: '── Notación Pro ──',
  tableLine: (n, blinds) => `${n}-max · ${blinds}`,
  errorBlinds: 'Ciegas no válidas. BB debe ser > 0; SB ≥ 0 y ≤ BB.',
  hintFlopPartial: 'El flop suele ser de 3 cartas',
  hintNoActions: 'Sin acciones también vale — «Terminar registro» comparte lo registrado hasta aquí',
  missingFlopBoard: 'Hay acciones de flop pero faltan cartas del flop',
  missingTurnBoard: 'Hay acciones de turn pero falta la carta de turn',
  missingRiverBoard: 'Hay acciones de river pero falta la carta de river',
  boardActionsMismatch: 'Acciones en una calle cuyo board está vacío',
  boardNeedFlop: 'El flop está vacío — añada cartas para una revisión más clara',
  boardNeedFlopPartial: 'Termine de introducir el flop',
  boardNeedTurn: 'Falta el turn — añádalo para una revisión más clara',
  boardNeedRiver: 'Falta el river — añádalo para una revisión más clara',

  softGateTitle: 'Algunos campos siguen vacíos',
  softGateBody: 'Aún faltan las hole cards. Añade holes para registrar el proceso, o continúa de todos modos.',
  softGateFix: "Añadir hole cards",
  softGateForceConfirm: "¿Compartir incompleto de todos modos?",
  softGateMissingHoles: (seat) => `Hole cards de ${seat} (2)`,
  softGateMissingActions: "Al menos una acción",
  softGateBodyLead: "Aún hace falta:",
  incompleteBadge: "Incompleto",
  softGateContinue: 'Ver resumen igual',
  softGateShare: 'Compartir igual',
  softGateCopy: 'Copiar igual',
  softGateCancel: 'Volver',
  pickerDisabled: 'Ningún slot seleccionado',
  step: {
    setup: 'Mesa',
    position: 'Asiento',
    cards: 'Mano',
    board: 'Board',
    actions: 'Línea',
    summary: 'Compartir',
  },
  street: {
    preflop: 'Preflop',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
  },
  actionType: {
    fold: 'Fold',
    check: 'Check',
    call: 'Call',
    bet: 'Bet',
    raise: 'Raise',
    allin: 'All-in',
  },
  suit: {
    s: 'Picas',
    h: 'Corazones',
    d: 'Diamantes',
    c: 'Tréboles',
  },
  positionHintMap: {
    UTG: 'Under the gun',
    "UTG+1": 'UTG+1',
    MP: 'Posición media',
    "MP+1": 'MP+1',
    HJ: 'Hijack',
    CO: 'Cutoff',
    BTN: 'Botón (dealer)',
    SB: 'Ciega pequeña',
    BB: 'Ciega grande',
  },
  progressAria: (current, total, label) =>
    `Paso ${current} de ${total}: ${label}`,
  adArea: 'Espacio publicitario',
  adTop: 'Anuncio superior',
  adBottom: 'Anuncio inferior',
  adPlaceholderHint: 'ID de AdSense sin definir — marcador hasta deploy',
  // Softwise M10b: memory-order input
  endHere: "Terminar aquí",
  finishRecord: "Terminar registro",
  reviewAnte: (v) => `ante ${v}`,
  reviewEffStack: (v) => `efect. ${v}`,
  reviewBreakdownAria: 'Por calle',
  reviewPlayers: (n) => `${n} jugadores`,
  // vocab-tags:start — screen-only poker vocabulary (review breakdown)
  reviewVocab: {
    trips: 'trips',
    paired: 'pareado',
    monotone: 'monocolor',
    twoTone: 'dos colores',
    rainbow: 'arcoíris',
    limp: 'limp',
    open: 'open',
    threeBet: '3-bet',
    fourBet: '4-bet',
    fiveBet: '5-bet',
    squeeze: 'squeeze',
    coldCall: 'cold call',
    checkRaise: 'check-raise',
    cBet: 'c-bet',
    donkBet: 'donk bet',
    probeBet: 'probe bet',
  },
  shareSavedMark: 'Guardado',
  // vocab-tags:end
  flowAskFlop: "Flop · 3 cartas",
  flowAskTurn: "Turn · 1 carta",
  flowAskRiver: "River · 1 carta",
  flowWhoActs: "Le toca",
  flowSizeCustom: "Otro",
  flowSizeConfirm: "OK",
  flowSizeLabel: "Tamaño (bb)",
  flowDone: "Línea registrada",
  flowRewind: "Rehacer desde aquí",
  flowRewindCancel: "Cancelar",
  flowSeatUnrecorded: "sin registrar",
  flowSeatNotInvolved: "no participa",
  flowMemoryCut: "No recuerdo más desde aquí",
  lineStripAria: "Línea registrada hasta ahora",
  // Soft G: optional ending record (L1.5) — seat-subject, press-only, Quiet
  endingSummary: 'Final (opcional)',
  endingShownLabel: 'Cartas mostradas en el showdown',
  endingPotLabel: 'Bote',
  endingCardsInput: 'Cartas',
  endingMuck: 'No mostradas (muck)',
  endingUnknown: 'Desconocido',
  endingPotTo: (seat) => `${seat} se lleva el bote`,
  endingSplit: 'Dividido',
  endingLineLabel: 'Final',
  endingShownCards: (seat, cards) => `${seat} muestra ${cards}`,
  endingShownMuck: (seat) => `${seat} no mostró (muck)`,
  endingShownUnknown: (seat) => `${seat} cartas desconocidas`,
  endingPotSplit: 'Bote dividido',
  endingPotUnknown: 'Bote desconocido',
  linkWithoutEndingToast: 'Enlace largo: se omitió el final',
  linkWithoutTakeawayToast: 'Enlace largo: se omitió la nota de proceso',
  endingShownAria: (seat) => `${seat} cartas del showdown`,
}

export default es
